import AuthContext from "context/AuthContext";
import { useContext } from "react";
import MeasureFilters from "./waste/MeasureFilters";
import MeasureFiltersBridge from "./bridge/MeasureFiltersBridge";


const ManagerParamsModel = { groups: [], device_groups: [], zones: [], routes: [], islands: [] };
const MeasureFiltersManager = ({ filters, params = { ...ManagerParamsModel } }) => {
    const { panel } = useContext(AuthContext);

    switch (panel.panel_type) {
        case 'b':
            return <MeasureFiltersBridge filters={filters} params={params} />
        default:
            return <MeasureFilters filters={filters} params={params} />
    }
};

export default MeasureFiltersManager;
